import { useState } from 'react';
import { When } from 'UI/components/atoms';

export const RevealOnce = ({ when, resetWhen = false, children }) => {
  const [isRevealed, setIsRevealed] = useState(() => !resetWhen && Boolean(when));

  if (resetWhen && isRevealed) {
    setIsRevealed(false);
  } else if (when && !resetWhen && !isRevealed) {
    setIsRevealed(true);
  }

  return <When condition={isRevealed}>{children}</When>;
};
